import { render, staticRenderFns } from "./luckdrawEntity_new.vue?vue&type=template&id=1fc432a1&scoped=true&"
import script from "./luckdrawEntity_new.vue?vue&type=script&lang=js&"
export * from "./luckdrawEntity_new.vue?vue&type=script&lang=js&"
import style0 from "./luckdrawEntity_new.vue?vue&type=style&index=0&id=1fc432a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc432a1",
  null
  
)

export default component.exports